(() => {
  if (window.domelyahAnimalPhotosReady) return;
  window.domelyahAnimalPhotosReady = true;
  const setup = root => {
    const cards = [...root.querySelectorAll('[data-dmp-review-card]')];
    const more = root.querySelector('[data-dmp-more]');
    if (!more || root.dataset.dmpReady) return;
    root.dataset.dmpReady = 'true';
    cards.forEach((card, index) => { card.hidden = index >= 6; });
    more.hidden = cards.length <= 6;
    root.querySelector('[data-dmp-progress]').textContent = `${Math.min(6, cards.length)} / ${cards.length}`;
  };
  document.querySelectorAll('.dmp-photos').forEach(setup);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.dmp-photos').forEach(setup);
  });
  document.addEventListener('click', event => {
    const bundleLink = event.target.closest('.dmp-story a[href="#dmp-product-anchor"], .dmp-family a[href="#dmp-product-anchor"]');
    if (bundleLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      const bundle = [...document.querySelectorAll('.main-product-form .rapi-header-title')].find(node => node.getClientRects().length)
        || document.querySelector('.main-product-form');
      if (bundle) {
        event.preventDefault();
        const header = document.querySelector('header');
        const offset = (header ? header.getBoundingClientRect().height : 80) + 20;
        window.scrollTo({
          top: Math.max(0, window.scrollY + bundle.getBoundingClientRect().top - offset),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
        bundle.setAttribute('tabindex', '-1');
        bundle.focus({ preventScroll: true });
      }
      return;
    }
    const more = event.target.closest('[data-dmp-more]');
    if (more) {
      const root = more.closest('.dmp-photos');
      const cards = [...root.querySelectorAll('[data-dmp-review-card]')];
      const hidden = cards.filter(card => card.hidden);
      hidden.slice(0, 6).forEach(card => { card.hidden = false; });
      const shown = cards.filter(card => !card.hidden).length;
      more.hidden = shown === cards.length;
      root.querySelector('[data-dmp-progress]').textContent = `${shown} / ${cards.length}`;
      return;
    }
    const trigger = event.target.closest('[data-dmp-photo]');
    if (trigger) {
      const root = trigger.closest('.dmp-photos');
      const dialog = root.querySelector('dialog');
      const photo = dialog.querySelector('img');
      photo.src = trigger.dataset.dmpPhoto;
      photo.alt = trigger.querySelector('img')?.alt || '';
      dialog.showModal();
      return;
    }
    const close = event.target.closest('.dmp-dialog-close');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog.dmp-photo-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
})();
